import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, computed } from 'vue'
import { useRoute } from "vue-router";
import { config } from "@/store";
import bookmarkApi from "@/api/bookmark";
import { ElMessageBox } from "element-plus";
import i18n from '@/i18n';
import { global_set_json } from '@/utils';

export default /*#__PURE__*/_defineComponent({
  __name: 'right-sidebar',
  props: ['info', 'menuPoster'],
  emits: ['reload'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = i18n.global;

const route = useRoute();

const drawer = ref(false)

const props = __props;
const emit = __emit

const chapterName = computed(() => {
  return props.info.chapterName
});

const chapterId = computed(() => {
  return props.info.chapterId
})

const bookmarkId = computed(() => {
  return props.info.bookmarkId
})

const blob = computed(() => {
  return props.menuPoster
})

watch(
  () => config.rightSidebar,
  (val) => {
    drawer.value = val;
  }
)

function close_sidebar() {
  config.rightSidebar = false;
}

function menu_select(key: string) {
  switch (key) {
    case 'delete':
      ElMessageBox.confirm(t('bookmarkManage.confirm.text'), { type: 'warning' }).then(async () => {
        await bookmarkApi.delete_and_update(bookmarkId.value);
        emit('reload');
      });

      break;
  }
  close_sidebar();
}

const __returned__ = { t, route, drawer, props, emit, chapterName, chapterId, bookmarkId, blob, close_sidebar, menu_select, get config() { return config } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})